import { createI18n } from 'vue-i18n';
import zh from './locales/zh';
import en from './locales/en';

const saved = localStorage.getItem('locale') || (navigator.language.startsWith('zh') ? 'zh' : 'en');

const i18n = createI18n({
  legacy: false,
  locale: saved,
  fallbackLocale: 'zh',
  messages: { zh, en },
});

export default i18n;

export function setLocale(locale: 'zh' | 'en') {
  (i18n.global.locale as { value: string }).value = locale;
  localStorage.setItem('locale', locale);
  document.documentElement.lang = locale;
}

export function getLocale(): string {
  return (i18n.global.locale as { value: string }).value;
}
